import {AnyAction} from 'redux';
import {CLEAR_ALL_DEPRECATIONS, DEPRECATE_SOURCE_TYPE, REMOVE_ALL_DEPRECATED_STATIONS, SET_INITIAL_DEPRECATIONS} from '../action';


/**
 * deprecate all power sources of a given type, permanently removing them
 */
export function deprecateSourceType(deprecate: string) : AnyAction
{
    return {type: DEPRECATE_SOURCE_TYPE, payload: {deprecate}};
}


/**
 * set the damage at the start of the year
 */
export function setInitialDeprecate(deprecations: boolean[]) : AnyAction
{
    return {type: SET_INITIAL_DEPRECATIONS, payload: {deprecations}};
}


/**
 * clear all deprecation
 */
export function clearAllDeprecations() : AnyAction
{
    return {type: CLEAR_ALL_DEPRECATIONS, payload: {}};
}


/**
 * remove all deprecated stations
 */
export function removeDeprecatedStations(deprecate_type: string) : AnyAction
{
    return {type: REMOVE_ALL_DEPRECATED_STATIONS, payload: {deprecate_type}};
}



/**
 * clear all deprecation
 */
export function clearDeprecateType() : AnyAction
{
    return {type: DEPRECATE_SOURCE_TYPE, payload: { deprecate: null }};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/power-sources/deprecate.ts